module.exports = __webpack_public_path__ + "user.png?7f7eb5232d8870b36eceeb52d9e69f38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = 40
// module chunks = 0